import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';
import { buildSymbolInfoCapsuleConfigSlice } from 'widgets/symbolInfo/capsule/store/config/configSlice';
import { SymbolInfoCapsuleState } from 'widgets/symbolInfo/capsule/store/SymbolInfoCapsuleState';
import { SymbolInfoCapsuleActionPayload } from 'widgets/symbolInfo/capsule/store/actions';

const { reducer: configReducer } = buildSymbolInfoCapsuleConfigSlice();

const symbolInfoCapsuleWidgetReducer = combineReducers<SymbolInfoCapsuleState>({
    config: configReducer,
});

export const symbolInfoCapsuleWidgetsReducer = createWidgetsReducer<
    SymbolInfoCapsuleState,
    SymbolInfoCapsuleActionPayload
>(WidgetType.SYMBOL_INFO_CAPSULE, symbolInfoCapsuleWidgetReducer);
